export const localStringToNumber = (s) =>
  Number(String(s).replace(/[^0-9.-]+/g, ""));

export const dollarFormat = new Intl.NumberFormat("en-US", {
  currency: "USD",
  style: "currency",
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});
